import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.css'],
})
export class SearchResultComponent {
  @Input() resultItem;
  resultTypeMapping = {
    0: 'country',
    1: 'state',
    2: 'county',
    3: 'city',
    4: 'zip',
    5: 'splc',
    6: 'street',
    7: 'routeNumber',
    9: 'poi',
    10: 'fullPostCode',
    11: 'poiType',
    12: 'none',
  };
  typeIcons = {
    country: 'frame',
    state: 'frame',
    county: 'frame',
    city: 'circle_dot_outline',
    zip: 'circle_dot_outline',
    splc: 'location_point',
    street: 'envelope',
    routeNumber: 'highway',
    routeAlpha: 'highway',
    poi: 'map_marker',
    fullPostCode: 'location_point',
    poiType: 'map_marker',
    none: 'location_point',
  };

  errorCallback(err): void {
    console.error(err);
  }

  getIcon(): string {
    const data = this.resultItem;
    let typeIcon = this.typeIcons.none;
    if (data.ResultType && data.ResultType in this.resultTypeMapping) {
      typeIcon = this.typeIcons[this.resultTypeMapping[data.ResultType]];
    } else {
      if (data.Address.City !== '') {
        typeIcon = this.typeIcons.city;
      }
      if (data.Address.Zip !== '') {
        typeIcon = this.typeIcons.zip;
      }
      if (data.Address.StreetAddress !== '') {
        typeIcon = this.typeIcons.street;
      }
      if (data.PlaceName !== '') {
        typeIcon = this.typeIcons.poi;
      }
    }
    return typeIcon;
  }

  // provideResultFunctionality(result) {
  //   result.toHTML = () => {
  //     let html = ``;
  //     if (result.POITypeID !== 0) {
  //       html = `<p><strong>${result.ShortString}</strong></p>`;
  //       html += `<p>${result.Address.StreetAddress}</p>`;
  //       html += `<p>${result.Address.City +
  //         ', ' +
  //         result.Address.State +
  //         ' ' +
  //         result.Address.Zip}</p>`;
  //     } else {
  //       html = `<p><strong>${result.Address.StreetAddress}</strong></p>`;
  //       html += `<p>${result.Address.City +
  //         ', ' +
  //         result.Address.State +
  //         ' ' +
  //         result.Address.Zip}</p>`;
  //     }
  //     return html;
  //   };

  //   result.getLngLat = () => {
  //     return {
  //       lng: Number(result.Coords.Lon),
  //       lat: Number(result.Coords.Lat),
  //     };
  //   };
  // }

  toHTML(): string {
    const result = this.resultItem;
    let html = '';
    if (result.POITypeID !== 0) {
      html = `<p><strong>${result.ShortString}</strong></p>`;
      html += `<p>${result.Address.StreetAddress}</p>`;
      html += `<p>${`${result.Address.City}, ${result.Address.State} ${result.Address.Zip}`}</p>`;
    } else {
      html = `<p><strong>${result.Address.StreetAddress}</strong></p>`;
      html += `<p>${`${result.Address.City}, ${result.Address.State} ${result.Address.Zip}`}</p>`;
    }
    return html;
  }
}
